import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createTheme } from "@mui/material/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { AllNews } from "./news/allNews";
import { AllCollaboration } from "./collaboration/allCollaboration";
import { AllContactUs } from "./contactUs/allContactUs";
import { AllSocialMedia } from "./socialMedia/allSocialMedia";
import { AllUsers } from "./users/allUsers";
import { AllNormalReservations } from "./reservations/allNormalReservations";
import { AllEventReservations } from "./reservations/allEventReservations";
import { AllModules } from "./settings/allModules";
import { AllFeatures } from "./settings/allFeatures";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  FaUser,
  FaHandshakeAngle,
  FaShareNodes,
  FaAddressCard,
  FaNewspaper,
  FaList,
  FaBook,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import {
  RiFunctionAddFill,
  RiSettings4Fill,
  RiFunctions,
} from "react-icons/ri";
import { NormalReservationReport } from "./reports/reservations/normalReservationReport";
import { EventReservationReport } from "./reports/reservations/eventReservationReport";
import { NormalReservationSettings } from "./reservations/normalReservationSettings";
import { EventReservationSettings } from "./reservations/eventReservationSettings";
import { CafeDetails } from "./settings/general/cafeDetails";
import { CollaborationDetails } from "./settings/general/collaborationDetails";
import { WebDetails } from "./settings/general/webDetails";
import { IoIosCafe } from "react-icons/io";
import { CgWebsite } from "react-icons/cg";
import { TbReport } from "react-icons/tb";
import { AllBOUsers } from "./users/allBOUsers";

const demoTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-toolpad-color-scheme",
  },
  colorSchemes: { light: true, dark: true },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});

function DemoPageContent({ pathname }) {
  return (
    <Box
      sx={{
        py: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography>Dashboard content for {pathname}</Typography>
    </Box>
  );
}

DemoPageContent.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export const HomePage = () => {
  const navigationPath = [
    {
      kind: "header",
      title: "Main items",
    },
    {
      segment: "dashboard",
      title: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      kind: "divider",
    },
    {
      kind: "header",
      title: "Modules",
    },
    {
      segment: "users",
      title: "Users",
      icon: <FaUser />,
      children: [
        {
          segment: "all",
          title: "Users Lists",
          icon: <FaList />,
        },
        {
          segment: "allBOUsers",
          title: "BO Users Lists",
          icon: <FaList />,
        },
      ],
    },
    {
      segment: "reservations",
      title: "Reservations",
      icon: <FaBook />,
      children: [
        {
          segment: "allNormal",
          title: "Normal Reservations Lists",
          icon: <FaList />,
        },
        {
          segment: "allEvent",
          title: "Event Reservations Lists",
          icon: <FaList />,
        },
        {
          segment: "normalSettings",
          title: "Normal Reservation Settings",
          icon: <RiSettings4Fill />,
        },
        {
          segment: "eventSettings",
          title: "Event Reservation Settings",
          icon: <RiSettings4Fill />,
        },
      ],
    },
    {
      segment: "news",
      title: "News",
      icon: <FaNewspaper />,
      children: [
        {
          segment: "all",
          title: "News Lists",
          icon: <FaList />,
        },
      ],
    },
    {
      segment: "collaboration",
      title: "Collaboration",
      icon: <FaHandshakeAngle />,
      children: [
        {
          segment: "all",
          title: "Collaboration Lists",
          icon: <FaList />,
        },
      ],
    },
    {
      segment: "contactUs",
      title: "Contact Us",
      icon: <FaAddressCard />,
      children: [
        {
          segment: "all",
          title: "Contact Us Lists",
          icon: <FaList />,
        },
      ],
    },
    {
      segment: "socialMedia",
      title: "Social Media",
      icon: <FaShareNodes />,
      children: [
        {
          segment: "all",
          title: "Social Media Lists",
          icon: <FaList />,
        },
      ],
    },
    {
      kind: "divider",
    },
    {
      kind: "header",
      title: "Reports",
    },
    {
      segment: "reports/reservations",
      title: "Reservations",
      icon: <FaBook />,
      children: [
        {
          segment: "normal",
          title: "Normal Reservations",
          icon: <TbReport />,
        },
        {
          segment: "event",
          title: "Event Reservations",
          icon: <TbReport />,
        },
      ],
    },
    {
      kind: "divider",
    },
    {
      kind: "header",
      title: "Settings",
    },
    {
      segment: "general",
      title: "General",
      icon: <RiSettings4Fill />,
      children: [
        {
          segment: "cafe",
          title: "Cafe",
          icon: <IoIosCafe />,
        },
        {
          segment: "collaboration",
          title: "Collaboration",
          icon: <FaHandshakeAngle />,
        },
        {
          segment: "web",
          title: "Web",
          icon: <CgWebsite />,
        },
      ],
    },
    {
      segment: "modules",
      title: "Modules",
      icon: <RiFunctionAddFill />,
    },
    {
      segment: "features",
      title: "Features",
      icon: <RiFunctions />,
    },
  ];
  const [pathname, setPathname] = React.useState("/dashboard");
  const nagivatePath = (pathname) => {
    switch (pathname) {
      case "/users/all":
        return <AllUsers user={{ uid: user.uid }} />;
      case "/users/allBOUsers":
        return <AllBOUsers user={{ uid: user.uid }} />;
      case "/reservations/allNormal":
        return <AllNormalReservations />;
      case "/reservations/allEvent":
        return <AllEventReservations />;
      case "/reservations/normalSettings":
        return <NormalReservationSettings user={{ uid: user.uid }} />;
      case "/reservations/eventSettings":
        return <EventReservationSettings user={{ uid: user.uid }} />;
      case "/news/all":
        return <AllNews user={{ uid: user.uid }} />;
      case "/collaboration/all":
        return <AllCollaboration user={{ uid: user.uid }} />;
      case "/contactUs/all":
        return <AllContactUs user={{ uid: user.uid }} />;
      case "/socialMedia/all":
        return <AllSocialMedia user={{ uid: user.uid }} />;
      case "/reports/reservations/normal":
        return <NormalReservationReport />;
      case "/reports/reservations/event":
        return <EventReservationReport />;
      case "/general/cafe":
        return <CafeDetails user={{ uid: user.uid }} />;
      case "/general/collaboration":
        return <CollaborationDetails user={{ uid: user.uid }} />;
      case "/general/web":
        return <WebDetails user={{ uid: user.uid }} />;
      case "/modules":
        return <AllModules user={{ uid: user.uid }} />;
      case "/features":
        return <AllFeatures user={{ uid: user.uid }} />;
      default:
        return <DemoPageContent pathname={pathname} />;
    }
  };
  const router = React.useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    };
  }, [pathname]);

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      toast.info(
        "You must login to perform the reservation.\nRedirecting to login page."
      );
      navigate("/login");
    }
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
  }, [navigate]);

  return (
    <AppProvider navigation={navigationPath} router={router} theme={demoTheme}>
      <DashboardLayout>{nagivatePath(pathname)}</DashboardLayout>
    </AppProvider>
  );
};
